export default __webpack_public_path__ + "static/media/57.4c0d4be3.png";